import * as React from 'react'
import styled from 'styled-components'
import {adminColors, theme} from '../theme'

interface IProps {
  className?: string
  value?: string | number
  label?: string | React.ReactNode
  placeHolder?: string
  onChange: (value: string) => void
  type: 'number' | 'text' | 'password' | 'email'
  width?: string
  required?: boolean
  icon?: React.ReactNode
}
class InputClass extends React.PureComponent<IProps> {
  static defaultProps: Pick<IProps, 'type' | 'required'> = {
    type: 'text',
    required: false
  }
  private onChange = (event: any) => {
    this.props.onChange(event.target.value)
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.props.label && <label>{this.props.label}</label>}
        {this.props.icon && <IconElement labeled={!!this.props.label}>{this.props.icon}</IconElement>}
        {this.props.required && <RequiredElement>*</RequiredElement>}
        <InputElement
          min={0}
          type={this.props.type}
          className={this.props.className}
          value={this.props.value || ''}
          placeholder={this.props.placeHolder}
          onChange={this.onChange}
        />
      </div>
    )
  }
}

const InputElement = styled.input`
  margin-top: 7px;
  display: block;
  border-radius: 4px;
  border: 1px solid ${theme.color.darkGray};
  box-shadow: none;
  width: 100%;
  font-size: ${theme.fontSize.small};
  padding: 0.8rem;
  background-color: #fff;
  color: #000;
  &::placeholder {
    color: ${theme.color.gray};
  }
  &:focus {
    outline: 0;
  }
`

const IconElement = styled.span<{labeled?: boolean}>`
  height: 100%;
  width: 24px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 6px;
  overflow: hidden;
  display: inline-block;
  z-index: 1;
  color: ${adminColors.color.lightGray};
  top: ${props => props.labeled && '5px'};
`

const RequiredElement = styled.span`
  position: absolute;
  right: 25px;
  color: red;
  z-index: 10;
`

export const Input = styled(InputClass)`
  width: ${props => props.width || '100%'};
  @media screen and (max-width: ${theme.breakPoints.mobileMax}px) {
    width: 100%;
    label {
      font-size: 1.5rem;
    }
  }
`
